/**
 * Activate a random slide on an OwlCarousel.
 */
(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.owlCarouselRandomize = {
    attach: function (context) {
      once('owlCarouselRandomize', '.owl-slider-wrapper', context).forEach(function (slider) {
        var dots = slider.querySelectorAll('.owl-dot');
        if (dots.length > 1) {
          var num = Math.floor(Math.random() * (dots.length - 1));
          if (num !== 0) {
            dots[num].click();
          }
        }
      });
    }
  };
})(Drupal, once);
